import React from 'react'

export function BasicTextField({ value }: { value: string }) {
	return (
		<div className='cell-data-text'>
			{value === null || value === undefined ? '-' : value}
		</div>
	)
}
